import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../../services/authService";
import { Status } from "../../types/status";
import {
  AuthBlock,
  AuthErrorMessage,
  AuthForm,
  AuthFormGroup,
  AuthFormTitle,
  AuthFormWrapper,
  AuthInput,
  AuthSubmitButton,
} from "./AuthStyles";

const AuthPage: React.FC = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    setError("");
  }, [formData.email, formData.password]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isFormValid = useMemo(() => formData.email.trim() !== "" && formData.password.trim() !== "", [formData]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!isFormValid) return;

    setIsLoading(true);
    setError("");

    try {
      const res = await authService.signIn(formData);

      if (res.status === Status.Success) {
        navigate("/");
        return;
      }
    } catch (e) {
      setError("Произошла ошибка при обращении к API");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthBlock>
      <AuthFormWrapper>
        <AuthFormTitle>Авторизация</AuthFormTitle>
        <AuthForm onSubmit={handleSubmit}>
          <AuthFormGroup>
            <AuthInput
              type="email"
              name="email"
              placeholder="email"
              value={formData.email}
              onChange={handleInputChange}
              $hasError={!!error}
              disabled={isLoading}
            />
          </AuthFormGroup>

          <AuthFormGroup>
            <AuthInput
              type="password"
              name="password"
              placeholder="пароль"
              value={formData.password}
              onChange={handleInputChange}
              $hasError={!!error}
              disabled={isLoading}
            />
          </AuthFormGroup>

          <AuthSubmitButton type="submit" $disabled={!isFormValid || isLoading}>
            {isLoading ? "Вход..." : "Войти"}
          </AuthSubmitButton>
        </AuthForm>

        {error && <AuthErrorMessage>{error}</AuthErrorMessage>}
      </AuthFormWrapper>
    </AuthBlock>
  );
};

export default AuthPage;
